var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-view"},[(_vm.show === 'login')?_c('div',{},[_c('login-component',{on:{"on-success":_vm.onLoginSuccess,"on-register-click":_vm.onRegisterClick}})],1):_vm._e(),(_vm.show === 'register')?_c('div',{},[_c('register-component',{on:{"on-success":_vm.onLoginSuccess,"on-login-click":_vm.onLoginClick}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }